import environments from './XEnvironment.js';
import { XPageReactive } from './XPage.js';
import { xArray, xObject, xReference, xString } from './XTypes.js';

export class XSite
{
    static get type () { return 'XSite'; }

    #startPage;

    constructor()
    {
        const domTypes = environments.active.domTypes;
    };

    get startPage () { return this.#startPage; }
};

export class XSiteReactive extends XSite
{
    static get specification () 
    {
        return xObject({
            $: XSite.type,
            route: xString(),
            startPage: xReference('XPage'),
            versionsAndLocales: xArray(xObject({
                version: xString(),
                name: xString(),
                locales: xArray(xString())
            }))
        });
    } 

    #data;
    #isEditor;
    #isTranslator;
    #storage;

    #startPage;

    constructor(id, editor=true, translator=false)
    {
        super();
        this.#isEditor = editor;
        this.#isTranslator = translator;
        this.#storage = environments.active.storage;
        this.#data = this.#storage.data[id];
        
        this.#startPage = new XPageReactive(this.#data.startPage, this);
        document.body = this.#startPage._dom.body._element;
    };



    get data         () { return this.#data;         }
    get isEditor     () { return this.#isEditor;     }
    get isTranslator () { return this.#isTranslator; }
    get storage      () { return this.#storage;      }
    get startPage    () { return this.#startPage;    }
};
